module.exports = __webpack_public_path__ + "img/photo_id_gen2.cf21d7c6.jpg";